<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import { sessionHelper, ddlHelper } from "@/utils";
import { SESSION, SHARED } from "@/constants";
import { mapState } from "vuex";
import { ROLE_MODULE } from "@/state/modules/role";
import { roleMethods } from "@/state/helpers";

export default {
  page: { title: i18n.t("label.listingX", [i18n.t("module.role")]) },
  components: { Layout, PageHeader },
  data() {
    return {
      title: i18n.t("label.listingX", [i18n.t("module.role")]),
      statusDdl: ddlHelper.getActivationStatus(true),
      currentPage: 1,
      filter: "",
      perPage: SHARED.DEFAULT_PAGE_SIZE,
      fields: [
        { key: "name", sortable: true, label: i18n.t("label.name") },
        { key: "permissions", sortable: false, label: i18n.t("label.permissions") },
        { key: "isActive", sortable: true, label: i18n.t("label.status") },
        { key: "action", sortable: false, label: i18n.t("label.action") },
      ],
      searchCriteria: {},
    };
  },
  computed: {
    ...mapState(ROLE_MODULE, ["status"]),
    tableRows() {
      return this.$store.state.role.list.data;
    },
    pagination() {
      return this.$store.state.role.list.pagination;
    },
  },
  created() {
    this.initSearchCriteria();
  },
  methods: {
    ...roleMethods,
    initSearchCriteria() {
      this.searchCriteria = {
        pageNumber: SHARED.DEFAULT_PAGE_NUMBER,
        pageSize: SHARED.DEFAULT_PAGE_SIZE,
        isActive: this.statusDdl[0].value,
        searchArray: [],
      };
      this.getList(this.searchCriteria);
    },
    getList(filter) {
      this.getAllRoles({ filter });
      this.searchCriteria = filter;
      sessionHelper.storeSearch(SESSION.ROLE_SEARCH, filter);
    },
    pageNavigation(pageNumber) {
      this.searchCriteria.pageNumber = pageNumber;
      this.getList(this.searchCriteria);
    },
    searchListing() {
      this.searchCriteria.pageNumber = SHARED.DEFAULT_PAGE_NUMBER;
      this.searchCriteria.searchArray = [this.filter];
      this.getList(this.searchCriteria);
    },
    toggleStatus(row) {
      this.updateRoleStatus({
        id: row.id,
        isActive: !row.isActive,
        filter: this.searchCriteria,
      });
    },
    goCreate() {
      this.$router.push({ name: "Role-create" });
    },
    goEdit(row) {
      this.$router.push({ name: "Role-update", params: { id: row.id } });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-2 mb-3">
              <div class="col-sm-12 col-md-6">
                <label class="d-inline-flex align-items-center">
                  {{ $t('label.search') }}
                  <b-form-input v-model="filter" type="search" class="form-control form-control-sm ml-2" @change="searchListing"></b-form-input>
                </label>
              </div>
              <div class="col-sm-12 col-md-6 text-md-right">
                <b-button v-if="$can('Create Role')" variant="primary" size="sm" @click="goCreate">
                  <i class="mdi mdi-plus mr-1"></i>{{ $t('label.createX', [$t('module.role')]) }}
                </b-button>
              </div>
            </div>
            <div class="table-responsive mb-0">
              <b-table :items="tableRows" :fields="fields" responsive="sm" :per-page="perPage">
                <template #cell(permissions)="data">
                  <b-badge variant="info" class="mr-1 mb-1" v-for="p in tableRows[data.index].permissions" :key="p">{{ p }}</b-badge>
                </template>
                <template #cell(isActive)="data">
                  <b-badge variant="success" v-if="tableRows[data.index].isActive">{{ $t('label.active') }}</b-badge>
                  <b-badge variant="secondary" v-else>{{ $t('label.inactive') }}</b-badge>
                </template>
                <template #cell(action)="data">
                  <a v-if="$can('Update Role')" href="javascript:void(0);" @click="goEdit(tableRows[data.index])" class="text-info mr-2" v-b-tooltip.hover :title="$t('label.updateX', [$t('module.role')])">
                    <i class="mdi mdi-pencil font-size-18"></i>
                  </a>
                  <a v-if="$can('Update Role')" href="javascript:void(0);" @click="toggleStatus(tableRows[data.index])" class="text-warning" v-b-tooltip.hover :title="$t('label.status')">
                    <i class="mdi mdi-power font-size-18"></i>
                  </a>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="pagination.total" :per-page="perPage" @change="pageNavigation"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
